import { render, staticRenderFns } from "./NflPlayerStats.vue?vue&type=template&id=77a9715c&scoped=true&"
import script from "./NflPlayerStats.vue?vue&type=script&lang=js&"
export * from "./NflPlayerStats.vue?vue&type=script&lang=js&"
import style0 from "./NflPlayerStats.vue?vue&type=style&index=0&id=77a9715c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a9715c",
  null
  
)

export default component.exports